// Truncate time in dateString
const formatDateInGantt = (dateString) => {
  if (typeof dateString !== 'string' || dateString.indexOf(' ') === -1) {
    return dateString;
  }
  return dateString.split(' ')[0];
};

export const calcDuration = (start, end, milestone) => {
  if (milestone) {
    return 0;
  }
  const startDate = new Date(start),
    endDate = new Date(end);
  const diff = endDate - startDate;
  if (isNaN(startDate) || isNaN(endDate) || diff < 0) {
    return 'N/A';
  }
  return Math.floor(diff / (1000 * 3600 * 24)) + 1;
};

export const GanttTooltip = {
  style: {
    color: '#ffffff',
    fontSize: '0.75rem',
    fontFamily: 'Helvetica Neue,Arial',
    opacity: 0,
  },
  useHTML: true,
  followPointer: true,
  shadow: false,
  formatter() {
    const that = this;
    const startDate = formatDateInGantt(that.point.startString);
    const endDate = formatDateInGantt(that.point.endString);

    if (that.point.isTick || that.point.isxAxisMinMax) {
      return false;
    }

    return `<div class="gantt-tooltip">
      <div class="tt-division">
        <div class="division-header">Start Date</div>
        <div class="division-body">${startDate}</div>
      </div>
      <div class="tt-division">
        <div class="division-header">End Date</div>
        <div class="division-body">${endDate}</div>
      </div>
      <div class="tt-division">
        <div class="division-header">Duration</div>
        <div class="division-body">${calcDuration(
          startDate,
          endDate,
          that.point.milestone,
        )}</div>
      </div>
      <div class="tt-division">
        <div class="division-header">Status</div>
        <div class="division-body">${that.point.status || 'Not Started'}</div>
      </div>
    </div>`;
  },
};
